export var GET_ALL_STORES = '[Stores] Get All';
export var GET_STORE = '[Stores] Get Store';
export var GET_ALL_STORES_SUCCESS = '[Stores] Get All Success';
export var GET_ALL_STORES_ERROR = '[Stores] Get All Error';
export var GET_STORE_SUCCESS = '[Stores] Get Store Success';
export var GET_STORE_ERROR = '[Stores] Get Store Error';
export var ADD_STORE = '[Store] Add';
export var ADD_STORE_SUCCESS = '[Store] Add Success';
export var ADD_STORE_ERROR = '[Store] Add Error';
export var UPDATE_STORE = '[Store] Update';
export var UPDATE_STORE_SUCCESS = '[Store] Update Success';
export var UPDATE_STORE_ERROR = '[Store] Update Error';
var GetAllStores = /** @class */ (function () {
    function GetAllStores() {
        this.type = GET_ALL_STORES;
    }
    return GetAllStores;
}());
export { GetAllStores };
var GetAllStoresSuccess = /** @class */ (function () {
    function GetAllStoresSuccess(payload) {
        this.payload = payload;
        this.type = GET_ALL_STORES_SUCCESS;
    }
    return GetAllStoresSuccess;
}());
export { GetAllStoresSuccess };
var GetAllStoresError = /** @class */ (function () {
    function GetAllStoresError(payload) {
        this.payload = payload;
        this.type = GET_ALL_STORES_ERROR;
    }
    return GetAllStoresError;
}());
export { GetAllStoresError };
var GetStore = /** @class */ (function () {
    function GetStore(payload) {
        this.payload = payload;
        this.type = GET_STORE;
    }
    return GetStore;
}());
export { GetStore };
var GetStoreSuccess = /** @class */ (function () {
    function GetStoreSuccess(payload) {
        this.payload = payload;
        this.type = GET_STORE_SUCCESS;
    }
    return GetStoreSuccess;
}());
export { GetStoreSuccess };
var GetStoreError = /** @class */ (function () {
    function GetStoreError(payload) {
        this.payload = payload;
        this.type = GET_STORE_ERROR;
    }
    return GetStoreError;
}());
export { GetStoreError };
var AddStore = /** @class */ (function () {
    function AddStore(payload) {
        this.payload = payload;
        this.type = ADD_STORE;
    }
    return AddStore;
}());
export { AddStore };
var AddStoreSuccess = /** @class */ (function () {
    function AddStoreSuccess(payload) {
        this.payload = payload;
        this.type = ADD_STORE_SUCCESS;
    }
    return AddStoreSuccess;
}());
export { AddStoreSuccess };
var AddStoreError = /** @class */ (function () {
    function AddStoreError(payload) {
        this.payload = payload;
        this.type = ADD_STORE_ERROR;
    }
    return AddStoreError;
}());
export { AddStoreError };
var UpdateStore = /** @class */ (function () {
    function UpdateStore(payload) {
        this.payload = payload;
        this.type = UPDATE_STORE;
    }
    return UpdateStore;
}());
export { UpdateStore };
var UpdateStoreSuccess = /** @class */ (function () {
    function UpdateStoreSuccess(payload) {
        this.payload = payload;
        this.type = UPDATE_STORE_SUCCESS;
    }
    return UpdateStoreSuccess;
}());
export { UpdateStoreSuccess };
var UpdateStoreError = /** @class */ (function () {
    function UpdateStoreError(payload) {
        this.payload = payload;
        this.type = UPDATE_STORE_ERROR;
    }
    return UpdateStoreError;
}());
export { UpdateStoreError };



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/stores/store/actions/store.actions.ts.pre-build-optimizer.js